// Port of api/fuel/app/classes/filter/search/games/rules/post/bgg_count.php
// Post rule that sets up count_index metadata for bgg_count_notrecommended to use.
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_count',
	priority: 100,
	match: function(rule, config, filter, data, results) {
		if (!results.meta) results.meta = {}
		results.meta.count_index = [Rule.value(rule)]
	},
	min: function(rule, config, filter, data, results) {
		if (!results.meta) results.meta = {}
		var from = Rule.value(rule)
		if (rule.logic.operand === '>') from += 1
		var index = []
		for (var i = from; i <= 100; i++) index.push(i)
		results.meta.count_index = index
	},
	max: function(rule, config, filter, data, results) {
		if (!results.meta) results.meta = {}
		var to = Rule.value(rule)
		if (rule.logic.operand === '<') to -= 1
		var index = []
		for (var i = 1; i <= to; i++) index.push(i)
		results.meta.count_index = index
	},
	range: function(rule, config, filter, data, results) {
		if (!results.meta) results.meta = {}
		var from = Rule.value(rule)
		var to = Rule.value(rule, 'to')
		var index = []
		for (var i = from; i <= to; i++) index.push(i)
		results.meta.count_index = index
	},
	tolerance: function(rule, config, filter, data, results) {
		if (!results.meta) results.meta = {}
		var from = Rule.value(rule) - Rule.value(rule, 'tolerance')
		var to = Rule.value(rule) + Rule.value(rule, 'tolerance')
		var index = []
		for (var i = from; i <= to; i++) index.push(i)
		results.meta.count_index = index
	}
})
